import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SettingsV2 from "./routes/SettingsV2";
import AnnouncementsManager from "./routes/AnnouncementsManager";
import PorfolioManager from "./routes/PortfolioManager";
import ProjectSettings from "./routes/ProjectSettings";
import ModuleSettings from "./routes/ModuleSettings";
import ModuleSettingsV2 from "Administrator/routes/SchoolSettings/routes/ModuleSettingsV2";

export default store => ({
  path: "settings",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-settings" */ "./components/Settings"
        ),
        import(
          /* webpackChunkName: "admin-settings" */ "./modules/SettingsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "settings",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    AnnouncementsManager(store),
    ProjectSettings(store),
    PorfolioManager(store),
    ModuleSettings(store),
    ModuleSettingsV2(store),
    SettingsV2(store),
  ],
});
